var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuitGuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5C11.7356 0.5 6.625 5.61062 6.625 11.875C6.625 15.7409 8.59125 19.1615 11.5504 21.2188C4.87975 23.822 0.125 30.322 0.125 37.875H3.375C3.375 30.7283 8.56038 24.7547 15.3594 23.5035L16.375 26.5H19.625L20.6406 23.5035C27.4396 24.7547 32.625 30.7283 32.625 37.875H35.875C35.875 30.322 31.1203 23.822 24.4496 21.2188C27.4071 19.1615 29.375 15.7409 29.375 11.875C29.375 5.61062 24.2644 0.5 18 0.5ZM18 3.75C22.5061 3.75 26.125 7.36888 26.125 11.875C26.125 16.3811 22.5061 20 18 20C13.4939 20 9.875 16.3811 9.875 11.875C9.875 7.36888 13.4939 3.75 18 3.75ZM16.375 28.125L14.75 37.875H21.25L19.625 28.125H16.375Z",
    fill: "#181F26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitGuy);
export default __webpack_public_path__ + "static/media/suit-guy.2ba6885c10541e83c3f2edf65fdb0651.svg";
export { ForwardRef as ReactComponent };